(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noble-clarify-education"] && !Shopify.designMode) return;
  try {
    
(() => {
 let queued = false;
 const update = () => {
  queued = false;
  const launcher = document.getElementById('appstle-loyalty-button');
  let overlap = false;
  if (document.querySelector('.noble-education') && matchMedia('(max-width:749px)').matches && launcher) {
   const rect = launcher.getBoundingClientRect();
   overlap = [...document.querySelectorAll('.noble-education p, .noble-education a, .noble-education summary')].some(el => {
    const box = el.getBoundingClientRect();
    return box.width && box.height && box.bottom > 0 && box.top < innerHeight && box.left < rect.right + 8 && box.right > rect.left - 8 && box.top < rect.bottom + 8 && box.bottom > rect.top - 8;
   });
  }
  document.body.toggleAttribute('data-noble-ritual-rewards-overlap', overlap);
 };
 const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
 addEventListener('scroll', schedule, {passive:true});
 addEventListener('resize', schedule, {passive:true});
 addEventListener('load', schedule, true);
 new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
 schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noble-rejuvenate-education"] && !Shopify.designMode) return;
  try {
    
(() => {
 let queued = false;
 const update = () => {
  queued = false;
  const launcher = document.getElementById('appstle-loyalty-button');
  let overlap = false;
  if (document.querySelector('.noble-education') && matchMedia('(max-width:749px)').matches && launcher) {
   const rect = launcher.getBoundingClientRect();
   overlap = [...document.querySelectorAll('.noble-education p, .noble-education a, .noble-education summary')].some(el => {
    const box = el.getBoundingClientRect();
    return box.width && box.height && box.bottom > 0 && box.top < innerHeight && box.left < rect.right + 8 && box.right > rect.left - 8 && box.top < rect.bottom + 8 && box.bottom > rect.top - 8;
   });
  }
  document.body.toggleAttribute('data-noble-ritual-rewards-overlap', overlap);
 };
 const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
 addEventListener('scroll', schedule, {passive:true});
 addEventListener('resize', schedule, {passive:true});
 addEventListener('load', schedule, true);
 new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
 schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noble-soothe-education"] && !Shopify.designMode) return;
  try {
    
(() => {
 let queued = false;
 const update = () => {
  queued = false;
  const launcher = document.getElementById('appstle-loyalty-button');
  let overlap = false;
  if (document.querySelector('.noble-education') && matchMedia('(max-width:749px)').matches && launcher) {
   const rect = launcher.getBoundingClientRect();
   overlap = [...document.querySelectorAll('.noble-education p, .noble-education a, .noble-education summary')].some(el => {
    const box = el.getBoundingClientRect();
    return box.width && box.height && box.bottom > 0 && box.top < innerHeight && box.left < rect.right + 8 && box.right > rect.left - 8 && box.top < rect.bottom + 8 && box.bottom > rect.top - 8;
   });
  }
  document.body.toggleAttribute('data-noble-ritual-rewards-overlap', overlap);
 };
 const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
 addEventListener('scroll', schedule, {passive:true});
 addEventListener('resize', schedule, {passive:true});
 addEventListener('load', schedule, true);
 new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
 schedule();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noble-starter-options"]) return;
  try {
    
  if (!customElements.get('noble-starter-options')) {
    customElements.define('noble-starter-options', class extends HTMLElement {
      connectedCallback() {
        this.start = () => {
          this.productInfo = document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
          if (!this.productInfo) return;
          this.observer = new MutationObserver(() => this.syncChoices());
          this.observer.observe(this.productInfo, { childList: true, subtree: true });
          this.variantHandler = event => {
            if (event.detail?.sectionId !== this.productInfo.dataset.section) return;
            const variant = event.detail.variant;
            if (!variant?.id) return;
            this.productInfo.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
              input.value = variant.id;
              input.disabled = !variant.available;
            });
            this.syncChoices();
          };
          document.addEventListener('variant:change', this.variantHandler);
          this.syncChoices();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, { once: true });
        else this.start();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        document.removeEventListener('DOMContentLoaded', this.start);
        document.removeEventListener('variant:change', this.variantHandler);
        this.wrapper?.remove();
      }
      makeChoice(labelText, values, suffix) {
        const container = document.createElement('div');
        container.className = 'product-form__input product-form__input--dropdown';
        const label = document.createElement('label');
        label.className = 'form__label';
        label.textContent = labelText;
        const frame = document.createElement('div');
        frame.className = 'select';
        const select = document.createElement('select');
        select.className = 'select__select';
        select.id = `NobleStarter-${this.dataset.productId}-${suffix}`;
        label.htmlFor = select.id;
        values.forEach(value => select.add(new Option(value, value)));
        const icon = this.productInfo.querySelector('variant-selects .select svg');
        frame.append(select);
        if (icon) frame.append(icon.cloneNode(true));
        container.append(label, frame);
        select.addEventListener('change', event => {
          event.stopPropagation();
          const combined = this.productInfo.querySelector('variant-selects[data-primary] select[data-noble-combined]');
          if (!combined) return;
          const value = `${this.face.value} + ${this.body.value}`;
          if (!Array.from(combined.options).some(option => option.value === value)) return;
          combined.value = value;
          combined.dispatchEvent(new Event('change', { bubbles: true }));
        });
        return { container, select };
      }
      syncChoices() {
        const picker = this.productInfo.querySelector('variant-selects[data-primary]');
        const combined = picker?.querySelectorAll('select')[2];
        if (!combined || !Array.from(combined.options).every(option => option.value.includes(' + '))) return;
        combined.dataset.nobleCombined = 'true';
        const original = combined.closest('.product-form__input');
        original.classList.add('noble-starter-combined');
        original.hidden = true;
        if (!this.wrapper?.isConnected) {
          const pairs = Array.from(combined.options, option => option.value.split(' + '));
          const faces = [...new Set(pairs.map(pair => pair[0]))];
          const bodies = [...new Set(pairs.map(pair => pair[1]))];
          this.wrapper = document.createElement('div');
          this.wrapper.className = 'noble-starter-choices';
          const face = this.makeChoice(this.dataset.faceLabel, faces, 'face');
          const body = this.makeChoice(this.dataset.bodyLabel, bodies, 'body');
          this.face = face.select;
          this.body = body.select;
          this.wrapper.append(face.container, body.container);
          picker.after(this.wrapper);
        }
        const [face, body] = combined.value.split(' + ');
        this.face.value = face;
        this.body.value = body;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noble-welcome-capture"]) return;
  try {
    
if(!customElements.get('noble-welcome'))customElements.define('noble-welcome',class extends HTMLElement{
 connectedCallback(){
  this.preview=this.dataset.preview==='true';
  if(this.preview&&window.Shopify?.theme?.role!=='unpublished'&&window.Shopify?.theme?.role!=='development')return;
  if(!this.preview&&(!this.dataset.code||this.dataset.enabled!=='true'))return;
  this.hidden=false;this.dialog=this.querySelector('dialog');this.preferences=new Map();this.events=[];this.timer=null;
  const key=k=>this.preview?k.replace('noble_welcome_','noble_welcome_preview_'):k;
  const read=k=>{try{return localStorage.getItem(key(k))}catch{return null}};const save=(k,v)=>{try{localStorage.setItem(key(k),v)}catch{}};
  const sessionRead=k=>{try{return sessionStorage.getItem(key(k))}catch{return null}};const sessionSave=(k,v)=>{try{sessionStorage.setItem(key(k),v)}catch{}};const sessionRemove=k=>{try{sessionStorage.removeItem(key(k))}catch{}};
  this.save=save;this.read=read;this.sessionSave=sessionSave;
  let storageReady=false;try{localStorage.setItem(key('noble_welcome_probe'),'1');localStorage.removeItem(key('noble_welcome_probe'));sessionStorage.setItem(key('noble_welcome_probe'),'1');sessionStorage.removeItem(key('noble_welcome_probe'));storageReady=true}catch{}
  const previewUrl=new URL(window.location.href);this.previewReset=this.preview&&previewUrl.searchParams.get('noble_welcome_reset')==='1';
  if(this.previewReset){for(const k of ['noble_welcome_seen','noble_welcome_pending','noble_welcome_confirmed'])sessionRemove(k);try{localStorage.removeItem(key('noble_welcome_dismissed'));localStorage.removeItem(key('noble_welcome_subscribed'))}catch{}previewUrl.searchParams.delete('noble_welcome_reset');history.replaceState(history.state,'',previewUrl.toString())}
  if(!this.preview&&this.dataset.knownSubscriber==='true'){this.hidden=true;return}
  this.canAutoOpen=()=>storageReady&&!sessionRead('noble_welcome_seen')&&!read('noble_welcome_subscribed')&&(!Number(read('noble_welcome_dismissed'))||Date.now()-Number(read('noble_welcome_dismissed'))>=14*86400000);
  this.sync=()=>{const names=[...this.preferences.keys()];this.preference=names.join(', ');this.querySelector('[data-interest-tags]').value=['newsletter','source_welcome-popup','shopify-forms-729169',...this.preferences.values()].join(',');this.querySelector('[data-selected-interest]').textContent=names.join(' + ');this.querySelector('[data-success-interests]').textContent=names.join(', ')||'your interests';this.querySelector('[data-continue]').disabled=!names.length;this.querySelectorAll('[data-interest]').forEach(b=>{const selected=this.preferences.has(b.dataset.interest);b.setAttribute('aria-pressed',String(selected));b.querySelector('span').textContent=selected?'✓':'+'})};
  let pending;try{pending=JSON.parse(sessionRead('noble_welcome_pending'))}catch{}if(pending&&Date.now()-pending.time<600000){this.preferences=new Map(pending.interests||[]);this.sync()}
  this.querySelector('.noble-welcome-tab').addEventListener('click',()=>this.open('reopen_tab'));
  this.querySelector('.noble-welcome-close').addEventListener('click',()=>this.dismiss());this.querySelectorAll('[data-dismiss]').forEach(x=>x.addEventListener('click',()=>this.dismiss()));
  this.dialog.addEventListener('cancel',e=>{e.preventDefault();this.dismiss()});this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dismiss()}});
  this.querySelectorAll('[data-interest]').forEach(b=>b.addEventListener('click',()=>{const selected=!this.preferences.has(b.dataset.interest);if(selected)this.preferences.set(b.dataset.interest,b.dataset.tag);else this.preferences.delete(b.dataset.interest);this.sync();this.track('preference_selected',{preference:b.dataset.tag,selected,interests:[...this.preferences.values()].join('|')})}));
  this.querySelector('[data-continue]').addEventListener('click',()=>{if(this.preferences.size){this.step('email');this.querySelector('[type=email]').focus()}});
  this.querySelector('.noble-welcome-back').addEventListener('click',()=>this.step('interest'));
  const form=this.querySelector('form');form.addEventListener('submit',e=>{if(!this.preferences.size){e.preventDefault();this.step('interest');return}if(!form.reportValidity()){e.preventDefault();return}if(this.preview){e.preventDefault();e.stopImmediatePropagation();this.save('noble_welcome_subscribed','1');sessionSave('noble_welcome_seen','1');this.querySelector('.noble-welcome-tab').hidden=true;this.step('success');return}sessionSave('noble_welcome_seen','1');sessionSave('noble_welcome_pending',JSON.stringify({interests:[...this.preferences],time:Date.now()}))});
  const success=this.querySelector('[data-signup-success]');if(success&&!this.preview&&pending&&Date.now()-pending.time<600000&&!sessionRead('noble_welcome_confirmed')){this.track('email_signup',{interests:[...this.preferences.values()].join('|')});this.save('noble_welcome_subscribed','1');sessionRemove('noble_welcome_pending');sessionSave('noble_welcome_confirmed','1');this.querySelector('.noble-welcome-tab').hidden=true;this.step('success');this.open('signup_success');this.querySelector('[data-discount-block]').hidden=false;this.querySelector('[data-copy-code]').textContent=this.dataset.code}
  this.querySelector('[data-copy-code]').addEventListener('click',async()=>{if(this.preview||!this.dataset.code)return;try{await navigator.clipboard.writeText(this.dataset.code);this.querySelector('[data-copy-status]').textContent='Copied. Use at checkout with this email.';this.track('discount_claimed',{interests:[...this.preferences.values()].join('|')})}catch{this.querySelector('[data-copy-status]').textContent='Select and copy your code.'}});
  if(this.querySelector('.noble-welcome-errors')){this.step(this.preferences.size?'email':'interest');this.open('form_error')}
  if(this.previewReset){this.step('interest');this.open('preview_reset')}
  else if(this.dataset.autoOpen==='true'&&this.canAutoOpen()){this.timer=setTimeout(()=>{if(this.canAutoOpen()&&!document.querySelector('dialog[open]'))this.open('timed')},Number(this.dataset.delay)*1000)}
  if(this.read('noble_welcome_subscribed'))this.querySelector('.noble-welcome-tab').hidden=true;
 }
 step(name){this.querySelectorAll('[data-step]').forEach(x=>x.hidden=x.dataset.step!==name);this.setAttribute('data-current-step',name);const h=this.querySelector('[data-step="'+name+'"] h2');if(h&&h.hasAttribute('tabindex'))h.focus()}
 open(source){clearTimeout(this.timer);if(!this.dialog.open){this.dialog.showModal();this.track('popup_view',{source});this.sessionSave('noble_welcome_seen','1')}}
 dismiss(){clearTimeout(this.timer);this.dialog.close();this.save('noble_welcome_dismissed',String(Date.now()));const tab=this.querySelector('.noble-welcome-tab');if(!tab.hidden)tab.focus()}
 track(name,params){const event={event:name,...params,capture_location:'welcome_popup'};this.events.push(event);this.setAttribute('data-event-log',JSON.stringify(this.events));if(this.preview)return;if(typeof window.gtag==='function')window.gtag('event',name,params);else{window.dataLayer=window.dataLayer||[];window.dataLayer.push(event)}}
 disconnectedCallback(){clearTimeout(this.timer)}
});

  } catch(e) { console.error(e); }
})();
})();
